exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-ugm-white[data-v-7738e44d]{background:#fff!important;color:#252c5f!important;border:1px solid #252c5f!important;border-radius:6px;padding:5px 10px;font-size:.8rem;cursor:pointer;transition:opacity .2s}.btn-ugm-white[data-v-7738e44d]:hover{opacity:.8}.btn-ugm-danger[data-v-7738e44d]{background:#dc3545!important;color:#fff!important;border:1px solid #dc3545!important;border-radius:6px;padding:5px 10px;font-size:.8rem;cursor:pointer;transition:opacity .2s}.btn-ugm-danger[data-v-7738e44d]:hover{opacity:.85}", ""]);

// exports
